/**
 * `utm_campaign` on every cash-fund "Unlock Offers" link in admin registry. Attribution only —
 * behaviour reads HONEYMOON_SEARCH_PARAM, because inbound acquisition UTM overwrites this slot.
 */
export const HONEYMOON_FUND_TRAVEL_UTM_CAMPAIGN = 'honeymoon_fund_travel';

/**
 * Marks a honeymoon search rather than a wedding-guest one, so the search page can drop the venue
 * and zoom to the honeymoon place.
 *
 * Its own param rather than the campaign: UTM slots are merged with whatever inbound campaign the
 * couple arrived on (`resolveAcquisitionAwareUtm`), so a marketing link could silently switch the
 * behaviour off. Nothing rewrites this one.
 */
export const HONEYMOON_SEARCH_PARAM = 'honeymoonSearch';
export const HONEYMOON_SEARCH_PARAM_VALUE = 'true';

/**
 * Where a honeymoon search came from, as a path and query on this event's honeymoon page ("the board
 * I was on", not just "Browse"). The search page's back link goes there. Read through
 * `honeymoonReturnHref`, which accepts nothing outside that page.
 */
export const HONEYMOON_RETURN_PARAM = 'honeymoonReturn';

/** A same-site path to this event's honeymoon page, or null: the value rides in a link anyone can edit. */
export const honeymoonReturnHref = (value: unknown, eventHandle: string): string | null => {
  if (typeof value !== 'string') return null;
  const page = `/${eventHandle}/edit/honeymoon`;
  const rest = value.slice(page.length);
  return value.startsWith(page) && (rest === '' || rest.startsWith('?')) ? value : null;
};
